import type {} from "@lit/react";
import { VirtualList as VirtualListElement, } from "@vaadin/virtual-list/vaadin-virtual-list.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { VirtualListElement, };
export type VirtualListEventMap = Readonly<{}>;
const events = {} as VirtualListEventMap;
export type VirtualListProps<T1> = WebComponentProps<VirtualListElement<T1>, VirtualListEventMap>;
export const VirtualList = createComponent({
    elementClass: VirtualListElement, events, react: React, tagName: "vaadin-virtual-list"
}) as <T1>(props: VirtualListProps<T1> & React.RefAttributes<VirtualListElement<T1>>) => React.ReactElement | null;
